export const labels = {
  projectInfo: {
    projectName: 'Project Name',
    projectOwner: 'Project Owner',
    projectContact: 'Project Contact',
    projectLandingPage: 'Landing Page',
    projectRepository: 'Repository',
    programmingLanguage: 'Programming Language',
    openSourceLicense: 'Open Source License',
    cdiscStandards: 'CDISC Standards',
    agreeWithCdiscCodeOfEthics: 'Agree With CDISC Code Of Ethics',
    projectMaturity: 'Maturity',
    user: 'User',
    logoUrl: 'Logo URL',
  },
  detailedDescription: {
    problem: 'Problem',
    solution: 'Solution',
    openSourceConsiderations: 'Open Source Considerations',
    maintenanceModel: 'Maintenance Model',
    projectSize: 'Project Size',
    contributors: 'Contributors',
    userDetails: 'Users',
    preRequisites: 'Pre-Requisites',
    projectServiceOptions: 'Project Service Options',
    sponsors: 'Sponsors',
    goalsObjectives: 'Goals Objectives',
    communications: 'Communications',
    additionalInformation: 'Additonal Information',
  },
};

export const descriptions = {
  projectInfo: {
    projectName: 'Name of the project.',
    projectOwner: 'Name of the project owner.',
    projectContact:
      'Name and email address(es) of the primary contact(s) for the project.',
    projectLandingPage:
      'Provide a link to the primary landing spot for project users.',
    projectRepository:
      'Include a link to the project repository (e.g. publicly accessible GitHub repository).',
    programmingLanguage:
      'What languages have been used to implement the software (e.g. Python, R, JavaScript, SAS, etc.)?',
    openSourceLicense:
      'Which open-source license will this or has this software been released under? If the software uses a proprietary license please include the license for review.',
    cdiscStandards:
      'How does this software support the implementation or development of the CDISC standards?',
    agreeWithCdiscCodeOfEthics:
      'Does the project leadership agree to the CDISC Code of Ethics and Conflict of Interest policy?',
    projectMaturity:
      'What level of maturity is this project: Development, Stable, or Deprecated)? ',
    user: "Describe a typical user of your project's finished product (e.g. data manager, programmer, study designer).",
    logoUrl:
      'If the project has a logo, provide URL to it. When submitted with the application, use relative path: ./logo.png',
  },
  detailedDescription: {
    problem: 'Describe the problem this software solves for your users?',
    solution:
      'Describe the unique value proposition for this software and/or how it is different from other existing solutions? ',
    openSourceConsiderations: 'Why is this software published as open-source?',
    maintenanceModel: 'How are issues reported?',
    projectSize:
      'Please provide a T-shirt estimation of the size of this project along with a rationale for your answer.',
    contributors:
      'What requirements does the project require contributors to meet (e.g. contribution license agreement, issue/change request addressing, code contribution (e.g. pull-requests), documentation to read, training, etc.)?',
    users:
      'What qualifications do the users need to have in order to work with the software?',
    preRequisites:
      'What are the pre-requisites or technical requirements for running',
    projectServiceOptions:
      "What service options will there be for this project's offering",
    sponsors: 'Is the project sponsored and, if so, by whom? ',
    goalsObjectives: 'What are the goals, objectives, roadmap of this project?',
    communications: 'How will this project keep its community informed? ',
    additionalInformation:
      'This is to collect any additional information you may wish to provide.',
  },
};
